/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "368")


  
    
export type API48441Item = {};
    
  



export interface API48441Req {
  
  /** (String) */
  leaderName?: string;
    
};



export interface API48441Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** String  */
  data?: string[];
  /**   */
  exceptionMsg?: string;
  
};


// 48441 查询OKR 周期

export interface IUseGetAPI48441Return {
  /** 查询OKR 周期: 接口请求状态 */
  isAPI48441Loading: boolean;
  /** 查询OKR 周期: 接口请求返回数据 */
  dataAPI48441: API48441Res;
  /**  查询OKR 周期: 接口数据请求方法 */
  fetchAPI48441Data:  (inputs: API48441Req, config?: YWRequestConfig) => Promise<API48441Res>;
  /** 查询OKR 周期: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48441 = ():IUseGetAPI48441Return => {
  let isMount = true;
  const [isAPI48441Loading, setIsAPI48441Loading] = useState(false);
  const [dataAPI48441, setDataAPI48441] = useState<API48441Res>({} as API48441Res);
  const requestUrl = `${basePath}/internal-control-biz/project/okr/period/list`;

  const fetchAPI48441Data = async (inputs: API48441Req, config?: YWRequestConfig): Promise<API48441Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48441Req>) || {}) as API48441Req;
    
  
    if ( isMount ) {
      setIsAPI48441Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48441Res>(`${basePath}/internal-control-biz/project/okr/period/list?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48441(res || {} as API48441Res);
        setIsAPI48441Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48441Loading(false);
      }
      return false as unknown as API48441Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48441Loading,
    dataAPI48441,
    fetchAPI48441Data,
    requestUrl,
  }
}

